<template>
  <div class="studentifno-addstudent-form">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <el-form-item label="姓名" label-width="100px" prop="studentName">
        <el-input
          v-model="ruleForm.studentName"
          autocomplete="off"
          placeholder="请输入姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="100px" label="性别" required>
        <el-radio-group v-model="ruleForm.sex">
          <el-radio label="男"></el-radio>
          <el-radio label="女"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="学号" label-width="100px" prop="studentNumber">
        <el-input
          v-model="ruleForm.studentNumber"
          autocomplete="off"
          placeholder="请输入学号"
        ></el-input>
      </el-form-item>
      <el-form-item label="班级职务" label-width="100px" prop="duty">
        <el-input
          v-model="ruleForm.duty"
          autocomplete="off"
          placeholder="请输入班级职务"
        ></el-input>
      </el-form-item>
      <el-form-item label="政治面貌" label-width="100px" prop="politicsStatus">
        <el-input
          v-model="ruleForm.politicsStatus"
          autocomplete="off"
          placeholder="请输入政治面貌"
        ></el-input>
      </el-form-item>
      <el-form-item label="政治面貌" label-width="100px" prop="politicsStatus">
        <el-input
          v-model="ruleForm.politicsStatus"
          autocomplete="off"
          placeholder="请输入政治面貌"
        ></el-input>
      </el-form-item>
      <el-form-item label="学生状态" label-width="100px" prop="status">
        <el-select v-model="ruleForm.status" placeholder="请选择">
          <el-option
            v-for="item in studentTypeList"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择班级:" prop="classNameVal" label-width="100px">
        <el-cascader
          v-model="ruleForm.classNameVal"
          placeholder="请选择班级"
          :props="classProps"
          :options="classSelect"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="家庭地址" label-width="100px" prop="address">
        <el-input
          v-model="ruleForm.address"
          autocomplete="off"
          placeholder="请输入家庭地址"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="form-btn">
      <!-- <el-button @click="dialogClose">取 消</el-button> -->
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["classSelect", "classProps", "studentTypeList"],
  data() {
    return {
      ruleForm: {
        studentName: "",
        studentNumber: "",
        address: "",
        duty: "",
        politicsStatus: "",
        classNameVal: "",
        status: "",
        sex: "男"
      },
      rules: {
        studentName: [
          { required: true, message: "请输入学生姓名", trigger: "blur" },
        ],
        // duty: [{ required: true, message: "请输入学生职务", trigger: "blur" }],
        // politicsStatus: [{ required: true, message: "请输入政治面貌", trigger: "blur" }],
        studentNumber: [
          { required: true, message: "请输入学生学号", trigger: "change" },
        ],
        classNameVal: [
          { required: true, message: "请选择班级", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  methods: {
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("formSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    reset() {
      this.ruleForm = {
        studentName: "",
        studentNumber: "",
        address: "",
        duty: "",
        politicsStatus: "",
        classNameVal: "",
        status: "",
        sex: "男"
      };
      this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./studentifno-addstudent-form.scss";
</style>
